<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ecg"
          label="ECG"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ecocardio"
          label="Ecocardio"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ddvi"
          label="DDVI"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.dsvi"
          label="DSVI"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.pp"
          label="PP"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.fac"
          label="FAC"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ao"
          label="AO"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ai"
          label="AI"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.valvulas"
          label="VALVULAS"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.fey"
          label="FEY"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.peg"
          label="PEG"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.met"
          label="METS"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.cf"
          label="CF"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.dopplerRenal"
          label="Doppler Renal"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.dopplerVenoso"
          label="Doppler Venoso"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.dopplerArterial"
          label="Doppler Arterial"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.dvCuello"
          label="DV CUELLO"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.spect"
          label="SPECT"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.spectFey"
          label="SPECT FEY"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.compromiso"
          label="Compromiso"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ccg"
          label="CCG"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.tci"
          label="TCI"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.da"
          label="DA"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.cx"
          label="CX"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.cd"
          label="CD"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.otra"
          label="Otra"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="values.otrosEstudios"
          label="Otros Estudios"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import evolucionJsonMixin from "../../../../mixins/evolucionJsonMixin";
export default {
  data() {
    return {
      values: {
        ecg: null,
        ecocardio: null,
        ddvi: null,
        dsvi: null,
        pp: null,
        fac: null,
        ao: null,
        ai: null,
        valvulas: null,
        fey: null,
        peg: null,
        met: null,
        cf: null,
        dopplerRenal: null,
        dopplerArterial: null,
        dopplerVenoso: null,
        dvCuello: null,
        spect: null,
        spectFey: null,
        compromiso: null,
        ccg: null,
        tci: null,
        da: null,
        cx: null,
        cd: null,
        otra: null,
        otrosEstudios: null,
      },
    };
  },
  mixins: [evolucionJsonMixin],
  computed: {
    camposRequeridos() {
      return false;
    },
    defaultValues() {
      return {
        ecg: null,
        ecocardio: null,
        ddvi: null,
        dsvi: null,
        pp: null,
        fac: null,
        ao: null,
        ai: null,
        valvulas: null,
        fey: null,
        peg: null,
        met: null,
        cf: null,
        dopplerRenal: null,
        dopplerArterial: null,
        dopplerVenoso: null,
        dvCuello: null,
        spect: null,
        spectFey: null,
        compromiso: null,
        ccg: null,
        tci: null,
        da: null,
        cx: null,
        cd: null,
        otra: null,
        otrosEstudios: null,
      };
    },
  },
  created() {
    this.values = { ...this.defaultValues };
  },
};
</script>
